'use client';
import Link from 'next/link';
import { socialProfilePath } from '@/lib/social/links';
import type { SocialComment } from '@/lib/social/types';
import { Avatar, Timestamp } from './ui';
import { RichPostText } from './rich-text';
import { PostGallery } from './post-gallery';
import { SocialVideo } from './media';

export function CommentMedia({ comment }: { comment: SocialComment }) {
  const media = comment.media || [];
  return media.length ? <div className="my-3 overflow-hidden rounded-xl border" data-post-interactive>{media[0].kind === 'video' ? <SocialVideo media={media[0]} compact /> : <PostGallery media={media} author={comment.author.displayName} compact />}</div> : null;
}
export function CommentPreview({ comment }: { comment: SocialComment }) {
  return <div data-post-interactive className="space-y-3 p-3"><div className="flex items-center gap-2"><Avatar profile={comment.author} small /><Link href={socialProfilePath(comment.author.handle)} className="text-xs font-semibold">{comment.author.displayName}</Link><Timestamp value={comment.createdAt} /></div><RichPostText body={comment.body} className="text-sm" /><CommentMedia comment={comment} />{comment.permalink && <Link href={comment.permalink} className="block text-xs font-medium underline underline-offset-4">Open original comment</Link>}</div>;
}
